export class Measure {
  id: number;
  factor: string;
  code: string;
  description: string;
  displayUnits: string;
  hasTotalCalculation: boolean;
  mostRecent: boolean;
  modifiedByUserName: string;
  modifiedDate: Date;
  errorMessage:string;
  order: number;
}
